import type { Biome } from '../map/types.js';

/** Simple grass tuft, 5 frames in order. */
export const GRASS_FRAMES_SIMPLE = [
  'deco_herbe_frame1.png',
  'deco_herbe_frame2.png',
  'deco_herbe_frame3.png',
  'deco_herbe_frame4.png',
  'deco_herbe_frame5.png',
];

/** Doubled (denser) grass tuft, 5 frames in order. */
export const GRASS_FRAMES_DOUBLE = [
  'deco_herbe_double_frame1.png',
  'deco_herbe_double_frame2.png',
  'deco_herbe_double_frame3.png',
  'deco_herbe_double_frame4.png',
  'deco_herbe_double_frame5.png',
];

/**
 * Build a ping-pong sequence: [a, b, c, d, e] → [a, b, c, d, e, d, c, b].
 * Combined with `loop: true` in AnimatedSprite, it cycles 1→2→3→4→5→4→3→2
 * then back to 1, exactly the bidirectional swing the spec calls for.
 */
export function pingPongFrames<T>(frames: T[]): T[] {
  if (frames.length <= 2) return frames.slice();
  return [...frames, ...frames.slice(1, -1).reverse()];
}

/**
 * Decoration density per biome (sprites per 1000 px² of region area).
 * Lush biomes get more grass; arid/cold ones get none.
 */
export const BIOME_DECO_DENSITY: Record<Biome, number> = {
  ocean: 0,
  coast: 0,
  beach: 0.25,
  plains: 1.6,
  forest: 1.9,
  deepforest: 1.2,
  desert: 0,
  swamp: 1.1,
  hills: 0.7,
  mountain: 0,
  snow: 0,
};

/** Castle sprites per tier (small / medium / large). Not currently rendered. */
export const CAPITAL_SPRITES = [
  'chateau_tier1.png',
  'chateau_tier2.png',
  'chateau_tier3.png',
] as const;
